/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useEffect, useState } from "react";
import ItemService from "../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import ConstantsList from "../../common/SupplierConstants";
import CustomerConstantsList from "../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../common/Validations";
import { InputField } from "../../Components/formElements/InputField";
import SupplierConstants from "../../common/SupplierConstants";
import SuccessModal from "../../Components/Modal/supplier_app/SuccessModal";
// import { appConfigFunc } from "../../redux/feature/appSlice";

//Redux
import { useSelector } from "react-redux";
import CustomerConstants from "../../common/CustomerConstants";

const Login = () => {
  const appConfig = useSelector((state) => state?.app?.appConfig);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  // let [email, setEmail] = useState("");
  let [forgotEmail, setForgotEmail] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotStep, setForgotStep] = useState("email"); // "email" | "otp" | "reset"
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpResendTimer, setOtpResendTimer] = useState(0);
  const [resetToken, setResetToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [button, setButton] = useState(true);

  const [formInputs, setFormInputs] = useState({
    email: "",
    password: "",
  });

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");

  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // USER LOGIN
  const handleLogin = () => {
    // event.preventDefault();
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    const loginId = String(formInputs.email || "").trim();
    let obj = {
      email: loginId,
      password: formInputs.password,
    };

    if (!loginId || formInputs.password === "") {
      toast.error("User ID, email, or mobile and password are required", {
        duration: 3000,
        position: "top-right",
      });
    } else {
      ItemService.login(obj).then((item) => {
        if (item?.status === 200) {
          toast.success(item?.message || "User registered successfully", {
            duration: 2000,
            position: "top-right",
          });
          const roles = item?.data?.roles || [];
          const privilegedRoles = [
            "MD",
            "CEO",
            "CFO",
            "FI-EXECUTIVE",
            "FI-MNGR",
            "SALES-OFFICER",
            "PROC-MNGR",
            "SALES-ADMIN",
            "PROC-SNR-MNGR",
            "DISPATCH",
            "PROC-HEAD",
            "QUALITYCHECK",
            "PROC-EXECUTIVE",
            "PROC-VP",
            "SALES-COORDINATOR",
            "STORE",
            "SALES-REPORT",
            "MD",
            "SALES-PCD",
          ];
          const hasPrivilegedRole = roles.some((r) =>
            privilegedRoles.includes(r.roleId),
          );
          const isVendor = roles.some((r) => r.roleId === "VENDOR");

          if (item?.data?.defaultAppCode === "ALL") {
            window.location = ConstantsList.APP_HOME;
          } else if (item?.data?.defaultAppCode === "CUSTOMER") {
            window.location = CustomerConstants.CUSTOMER_V2_DASHBOARD;
          } else if (item?.data?.defaultAppCode === "SUPPLIER") {
            if (hasPrivilegedRole) {
              window.location = CustomerConstants.CUSTOMER_V2_DASHBOARD;
            } else if (isVendor) {
              window.location = CustomerConstants.DASHBOARD;
            } else {
              window.location = CustomerConstants.CUSTOMER_V2_DASHBOARD;
            }
          } else {
            window.location = CustomerConstants.CUSTOMER_V2_DASHBOARD;
          }
        } else {
          toast.error(item?.message || "Invalid input", {
            duration: 4000,
            position: "top-right",
          });
        }
      });
    }

    toast.dismiss(toastId);
  };

  const handleForgotPass = async () => {
    setForgotPassword(!forgotPassword);
    setForgotEmail("");
    setForgotStep("email");
    setOtpDigits(["", "", "", "", "", ""]);
    setOtpResendTimer(0);
    setResetToken("");
    setNewPassword("");
    setConfirmPassword("");
    setSuccessMsg("");
    setErrorMsg("");
  };

  const confirmForgotPassword = async () => {
    if (validateEmail(forgotEmail)) {
      let obj = { queryName: "ValidateEmail", validate: forgotEmail };
      await ItemService.checkValidation(obj).then(async (item) => {
        if (item.status === 200) {
          setButton(false);
          setErrorMsg("Email ID Not Found");
          setSuccessMsg("");
        } else {
          setButton(true);
          setSuccessMsg("Email ID Verified");
          setErrorMsg("");
          await new Promise((r) => setTimeout(r, 1000));
          sendMail();
        }
      });
      return;
    }
  };

  const sendMail = async () => {
    let obj = { email: forgotEmail };
    await ItemService.forgotPassword(obj).then(async (item) => {
      if (item.status === 200) {
        setErrorMsg("");
        setSuccessMsg("OTP sent to your email");
        setForgotStep("otp");
        setOtpDigits(["", "", "", "", "", ""]);
        setOtpResendTimer(120);
      } else {
        setSuccessMsg("");
        setErrorMsg("Something went wrong !!");
      }
    });
  };
  const handleOtpChange = (index, value) => {
    if (value.length > 1) {
      value = value.slice(-1);
    }
    if (value && !/^\d$/.test(value)) return;
    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);
    if (value && index < 5) {
      const nextInput = document.querySelector(
        `input[name="otp-${index + 1}"]`,
      );
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      const prevInput = document.querySelector(
        `input[name="otp-${index - 1}"]`,
      );
      if (prevInput) prevInput.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);
    if (pasted) {
      const newOtp = [...otpDigits];
      for (let i = 0; i < pasted.length; i++) {
        newOtp[i] = pasted[i];
      }
      setOtpDigits(newOtp);
      const lastIdx = Math.min(pasted.length, 6) - 1;
      const targetInput = document.querySelector(
        `input[name="otp-${lastIdx}"]`,
      );
      if (targetInput) targetInput.focus();
    }
  };

  const handleVerifyOtp = async () => {
    const otp = otpDigits.join("");
    if (otp.length !== 6) {
      setErrorMsg("Please enter the complete 6-digit OTP");
      setSuccessMsg("");
      return;
    }
    setErrorMsg("");
    let obj = { email: forgotEmail, otp: otp };
    await ItemService.verifyOtp(obj).then(async (item) => {
      if (item.status === 200) {
        setResetToken(item.token);
        setForgotStep("reset");
        setSuccessMsg("OTP verified successfully");
        setErrorMsg("");
      } else {
        setSuccessMsg("");
        setErrorMsg(item.message || "Invalid OTP");
      }
    });
  };

  const handleResendOtp = async () => {
    if (otpResendTimer > 0) return;
    setOtpDigits(["", "", "", "", "", ""]);
    setErrorMsg("");
    setSuccessMsg("");
    await sendMail();
  };

  const getPasswordStrength = (pwd) => {
    if (!pwd) return { label: "", color: "", width: "0%" };
    let score = 0;
    if (pwd.length >= 6) score++;
    if (pwd.length >= 10) score++;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[^A-Za-z0-9]/.test(pwd)) score++;
    if (score <= 1) return { label: "Poor", color: "#ef4444", width: "33%" };
    if (score <= 3) return { label: "Medium", color: "#eab308", width: "66%" };
    return { label: "Strong", color: "#22c55e", width: "100%" };
  };

  const passwordStrength = getPasswordStrength(newPassword);

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      setErrorMsg("Please fill in both password fields");
      setSuccessMsg("");
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMsg("Passwords do not match");
      setSuccessMsg("");
      return;
    }

    setErrorMsg("");
    let obj = { email: forgotEmail, newPassword: newPassword };
    await ItemService.resetPassword(obj, resetToken).then(async (item) => {
      if (item.status === 200) {
        setSuccessMsg("Password reset successful");
        setErrorMsg("");
        toast.success("Password reset successful! Please login.", {
          duration: 3000,
          position: "top-right",
        });
        handleForgotPass();
      } else {
        setSuccessMsg("");
        setErrorMsg(item.message || "Failed to reset password");
      }
    });
  };

  const onInputChange = ({ target: { name, value } }) => {
    setForgotEmail(value);

    if (validateEmail(name === "forgotEmail" ? value : "")) {
      setErrorMsg("");
      setSuccessMsg("");
      setButton(false);
    } else {
      setErrorMsg("Please enter a valid email address.");
      setSuccessMsg("");
      setButton(true);
    }
  };

  const onInputChangeLogin = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const handleCheckValidation = async ({ target: { name, value } }) => {
    let obj = {};
    if (value) {
      if (validateEmail(value)) {
        obj = { queryName: "ValidateEmail", validate: value };
        await ItemService.checkValidation(obj).then((item) => {
          // console.log(">> item", item);

          if (item.status === 200) {
            setErrorMsg("Email ID Not Found");
            setSuccessMsg("");
          } else {
            setSuccessMsg("Email ID Verified");
            setErrorMsg("");
          }
        });
      }
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        // console.log("Enter key pressed!");
        handleLogin(event);
      }
    };

    // Attach event listener
    document.addEventListener("keydown", handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs]);

  useEffect(() => {
    console.log(">> Login Page");
    const token = localStorage.getItem("token");
    if (token) {
      window.location = "/home";
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const isEmpty = Object.keys(appConfig).length === 0;

    if (isEmpty) {
      console.log("appConfig is empty");
    } else {
      console.log("appConfig is not empty");
    }

    // eslint-disable-next-line
  }, [appConfig]);

  useEffect(() => {
    if (otpResendTimer <= 0) return;
    const interval = setInterval(() => {
      setOtpResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [otpResendTimer]);

  const handleRegister = () => {
    navigate(ConstantsList.SELF_REGISTRATION);
  };
  const handleCustomerRegister = () => {
    if (appConfig?.customerName === "Medirent Services Pvt. Ltd") {
      navigate(CustomerConstantsList.SUPPLIER_V5_SELFREGISTARTION);
    } else {
      navigate(CustomerConstantsList.CUSTOMER_V1_REGISTER_LOGIN);
    }
  };

  const appStyle = {
    backgroundImage: `url(${process.env.REACT_APP_LOGIN_BG_IMG})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top",
    height: "124vh",
    // margin: "0",
    position: "relative" /* Required for positioning the overlay */,
  };

  return (
    <div className="loginBackground" style={appStyle}>
      <div className="overlay"></div>
      <main>
        <div className="">
          <section className="section register d-flex flex-column align-items-center justify-content-center pt-2">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-12 col-sm-12 d-flex flex-column">
                  <h1 className=" pt-sm-0 d-flex justify-content-center align-items-end">
                    {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS ===
                      "1" && (
                      <>
                        {/* <img
                          className="img-fluid headerLogo"
                          src={appConfig?.productLogo}
                          alt="productLogo"
                        /> */}
                        {/* <div className="d-flex-column ms-2 mb-2 text-left">
                          <h1 className="m-0 title">
                            {appConfig?.productTitle}
                          </h1>
                          <p className="m-0 fs-
                          5 ">
                            {appConfig?.productDescription}
                          </p>
                        </div> */}
                      </>
                    )}

                    {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS ===
                      "0" && (
                      <>
                        <div className="mt-6">&nbsp;</div>
                      </>
                    )}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-8 col-md-9 col-sm-8 d-flex flex-column align-items-center justify-content-center pt-lg-5 pt-sm-0"></div>
                <div className="col-lg-4 col-md-3 col-sm-4 d-flex flex-column innerLoginBox">
                  {!forgotPassword && (
                    <div className="card">
                      <div className="card-body">
                        <div
                          className="col-12"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS ===
                          "1" ? (
                            <>
                              <img
                                src={appConfig?.customerLogo1}
                                alt=""
                                className="loginLogo"
                                style={{ width: "150px" }}
                              />
                              {/* <div className="d-flex-column ms-2">
                                <p className="m-0 fs-3 fw-medium text-white">
                                  ATILA
                                </p>
                                <p className="m-0 fw-medium text-white">
                                  Revolutionizing Your Supply Chain
                                </p>
                              </div> */}
                            </>
                          ) : (
                            <>
                              <img
                                src={appConfig?.productLogo}
                                alt=""
                                className="loginLogo"
                                style={{ width: "270px" }}
                              />
                            </>
                          )}
                        </div>

                        <div className="pb-2">
                          <div className="card-title text-left">
                            {t("msg_login.msg_title1")}
                            <h6>{t("msg_login.msg_title2")}</h6>
                          </div>
                        </div>

                        <div className="row g-3 needs-validation">
                          <div className="col-12 leftAl">
                            <label className="form-label loingFont">
                              {t("msg_login.msg_username")}
                            </label>
                            <div className="input-group has-validation">
                              <input
                                type="text"
                                name="email"
                                value={formInputs.email || ""}
                                className="form-control"
                                id="email"
                                placeholder="User ID, email, or mobile"
                                onChange={onInputChangeLogin}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-12 leftAl">
                            <label className="form-label loingFont">
                              {t("msg_login.msg_password")}
                            </label>
                            <div className="forgot-pass">
                              <button
                                type="button"
                                // className="form-check-label text-secondary"
                                // className="text-gray-100 hover:text-sky-300 hover: transition duration-100 text-sm"
                                className="text-[14px] font-medium text-blue-500 hover:text-blue-600 transition-all duration-100 cursor-pointer"
                                onClick={handleForgotPass}
                              >
                                {" "}
                                {t("msg_login.msg_password_forgot")}
                              </button>
                            </div>
                            <div className="input-group has-validation">
                              <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formInputs.password || ""}
                                className="form-control"
                                id="password"
                                onChange={onInputChangeLogin}
                                required
                              />
                              <button
                                type="button"
                                aria-label="Toggle password visibility"
                                className="eyeCss absolute inset-y-0 right-0 flex items-center justify-center pr-3 h-full"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? (
                                  <i className="bi bi-eye-fill"></i>
                                ) : (
                                  <i className="bi bi-eye-slash-fill"></i>
                                )}
                              </button>
                            </div>
                          </div>

                          {/* <div className="col-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe" />
                                <label className="form-check-label" htmlFor="rememberMe">Stay signed in</label>
                            </div>
                          </div> */}
                          <div className="col-12 mt-5">
                            <button
                              className="btn btn-primary w-100"
                              onClick={handleLogin}
                            >
                              {t("msg_login.msg_login")}
                            </button>
                          </div>

                          {process.env.REACT_APP_CUSTOMER_V1 === "0" ? (
                            <div className="col-12 mt-2 mb-2">
                              <button
                                className="btn btn-primary w-100"
                                onClick={handleRegister}
                              >
                                {t("msg_login.msg_self_register")}
                              </button>
                            </div>
                          ) : (
                            <div className="col-12 mt-2 mb-2">
                              <button
                                className="btn btn-primary w-100"
                                onClick={handleCustomerRegister}
                              >
                                Registration
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Step 1: Enter Email */}
                  {forgotPassword && forgotStep === "email" && (
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="pb-2">
                          <h5 className="card-title text-left">
                            Reset your password
                          </h5>
                          <p className="subText">
                            Enter the email address associated with your account
                            and we'll send you an OTP to reset your password.
                          </p>
                        </div>

                        <div className="row g-3 needs-validation">
                          <div className="col-12 leftAl">
                            <InputField
                              className="inputBox"
                              label="Email"
                              name="forgotEmail"
                              placeholder=""
                              value={forgotEmail || ""}
                              onChange={onInputChange}
                              onBlur={handleCheckValidation}
                              required={true}
                              success={successMsg}
                              error={errorMsg}
                            />
                          </div>

                          <div className="col-12">
                            <button
                              className="btn btn-primary w-100"
                              onClick={confirmForgotPassword}
                              disabled={button}
                            >
                              Send OTP
                            </button>
                            <div className="form-signin">
                              <a
                                href="#"
                                className="form-signin-lable"
                                onClick={handleForgotPass}
                              >
                                Return to sign in
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Step 2: OTP Verification */}
                  {forgotPassword && forgotStep === "otp" && (
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="pb-2">
                          <h5 className="card-title text-center">
                            OTP Verification
                          </h5>
                          <p className="subText text-gray-200 text-center">
                            Enter the 6-digit OTP sent to {forgotEmail}
                          </p>
                        </div>

                        <div className="row g-3 needs-validation justify-content-center">
                          {otpDigits.map((digit, index) => (
                            <div className="col-2 px-1" key={index}>
                              <input
                                className="form-control text-center fs-4 fw-bold"
                                name={`otp-${index}`}
                                type="text"
                                inputMode="numeric"
                                maxLength="1"
                                value={digit}
                                onChange={(e) =>
                                  handleOtpChange(index, e.target.value)
                                }
                                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                onPaste={handleOtpPaste}
                                style={{ width: "100%", height: "50px" }}
                              />
                            </div>
                          ))}
                        </div>

                        {errorMsg && (
                          <div className="text-center mt-2">
                            <span className="text-red-500 text-sm">
                              {errorMsg}
                            </span>
                          </div>
                        )}
                        {successMsg && (
                          <div className="text-center mt-2">
                            <span className="text-green-600 text-sm">
                              {successMsg}
                            </span>
                          </div>
                        )}

                        <div className="col-12 mt-3">
                          <button
                            className="btn btn-primary w-100"
                            onClick={handleVerifyOtp}
                          >
                            Verify OTP
                          </button>
                          <div className="form-signin text-center mt-2">
                            <span className="text-gray-200">
                              Didn't receive the OTP?{" "}
                              {otpResendTimer > 0 ? (
                                <span className="text-gray-400">
                                  Resend in {Math.floor(otpResendTimer / 60)}:
                                  {String(otpResendTimer % 60).padStart(2, "0")}
                                </span>
                              ) : (
                                <a
                                  href="#"
                                  className="form-signin-lable"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleResendOtp();
                                  }}
                                >
                                  Resend
                                </a>
                              )}
                            </span>
                          </div>
                          <div className="form-signin text-center mt-1">
                            <a
                              href="#"
                              className="form-signin-lable"
                              onClick={(e) => {
                                e.preventDefault();
                                handleForgotPass();
                              }}
                            >
                              Return to sign in
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Step 3: Reset Password */}
                  {forgotPassword && forgotStep === "reset" && (
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="pb-2">
                          <h5 className="card-title text-center">
                            Reset Your Password
                          </h5>
                          <p className="subText text-gray-200 text-center">
                            Enter your new password
                          </p>
                        </div>

                        <div className="row g-3 needs-validation">
                          <div className="col-12 leftAl">
                            <label className="form-label loingFont">
                              New Password{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="input-group has-validation">
                              <input
                                type="password"
                                name="newPassword"
                                value={newPassword}
                                className="form-control"
                                placeholder="Enter new password"
                                onChange={(e) => setNewPassword(e.target.value)}
                              />
                            </div>
                            {newPassword && (
                              <div style={{ marginTop: "6px" }}>
                                <div
                                  style={{
                                    height: "5px",
                                    borderRadius: "4px",
                                    backgroundColor: "#e5e7eb",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      height: "100%",
                                      width: passwordStrength.width,
                                      backgroundColor: passwordStrength.color,
                                      borderRadius: "4px",
                                      transition:
                                        "width 0.4s ease, background-color 0.4s ease",
                                    }}
                                  />
                                </div>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: passwordStrength.color,
                                    transition: "color 0.4s ease",
                                  }}
                                >
                                  {passwordStrength.label}
                                </span>
                              </div>
                            )}
                          </div>

                          <div className="col-12 leftAl">
                            <label className="form-label loingFont">
                              Confirm Password{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="input-group has-validation">
                              <input
                                type="password"
                                name="confirmPassword"
                                value={confirmPassword}
                                className="form-control"
                                placeholder="Confirm new password"
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          {errorMsg && (
                            <div className="col-12">
                              <span className="text-red-500 text-sm">
                                {errorMsg}
                              </span>
                            </div>
                          )}
                          {successMsg && (
                            <div className="col-12">
                              <span className="text-green-600 text-sm">
                                {successMsg}
                              </span>
                            </div>
                          )}

                          <div className="col-12 mt-3">
                            <button
                              className="btn btn-primary w-100"
                              onClick={handleResetPassword}
                            >
                              Reset Password
                            </button>
                            <div className="form-signin text-center mt-2">
                              <a
                                href="#"
                                className="form-signin-lable"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleForgotPass();
                                }}
                              >
                                Return to sign in
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-12">
                    {/* <p className="small mb-0">
                      <a
                        href={ConstantsList.SUPPLIER_MASTER_CREATE}
                        className="form-check-label"
                      >
                        Self Registration
                      </a>
                    </p> */}

                    {/* <div className="footer pt-2">
                      <a href="/" className='footerLink'> 
                        &copy; supplier_app
                      </a>
                      <a href="/" className='footerLink'> 
                        Privacy & terms
                      </a> 
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS === "1" ? (
              <div className="w-100 text-end mr-3">
                <p className="copyright">{appConfig?.companyTitle}</p>
              </div>
            ) : (
              <></>
            )}
          </section>
        </div>
      </main>

      {/* Success Modal */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
    </div>
  );
};

export default Login;
